
import { v4 as uuidv4 } from "uuid";

import { SpellLevel } from "@dndModels/Types";

/**
 * This is a generic term for Spell Slots, Ki Points, Sorcery Points,
 * Lay on Hands, Healing Light, etc.  
 * It also could work for Material Spell Components, but I don't 
 * want to worry about that right now.
 * level is for spell slots (and pact slots), 
 * and it's what level the slot is.
 * total is the total number of that resource they have.
 * used is how many of them are currently used.
 * refreshRule is when this refreshes (generally short or long).
 */
export class CharacterSlot {
  type_id = ""; // ID of the table it connects to
  level: SpellLevel = 1;
  true_total = 0;
  true_used = 0;
  true_created = 0;
  slot_name = "";

  _resource_true_id = "";
  get resource_true_id() {
    return this._resource_true_id !== "" ? this._resource_true_id : `${this.slot_name}_${this.level}_${this.type_id}`;
  }
  set resource_true_id(value: string) {
    this._resource_true_id = value;
  }

  constructor(obj?: any) {
    this.type_id = obj ? obj.type_id : "";
    this.level = obj ? obj.level : 1;
    this.true_total = obj ? +obj.total : 0;
    this.true_used = obj ? +obj.used : 0;
    this.true_created = obj && obj.created ? +obj.created : 0;
    this.slot_name = obj && obj.slot_name ? obj.slot_name : "";
  }

  toDBObj(): any {
    return {
      type_id: this.type_id,
      level: this.level,
      total: this.true_total,
      used: this.true_used,
      created: this.true_created
    };
  }

  get total(): number {
    return this.true_total + this.created;
  }

  set total(value: number) {
    this.true_total = value;
  }

  get created(): number {
    return this.true_created;
  }

  set created(value: number) {
    if (this.true_used > 0) {
      this.true_used -= value;
      if (this.true_used < 0) {
        this.true_created = -1 * this.true_used;
        this.true_used = 0;
      }
    } else {
      this.true_created = value;
    }
  }

  get used(): number {
    return this.true_used;
  }

  set used(value: number) {
    if (this.true_created > 0) {
      this.true_created -= value;
      if (this.true_created < 0) {
        if (this.true_total > 0) {
          this.true_used = -1 * this.true_created;
          if (this.true_used < 0) {
            this.true_used = 0;
          }
        }
        this.true_created = 0;
      }
    } else {
      this.true_used = value;
    }
  }

  get is_resource(): boolean {
    return this._resource_true_id !== "";
  }

  clone(): CharacterSlot {
    const clone = new CharacterSlot();
    clone.copy(this);
    return clone;
  }

  copy(copyMe: CharacterSlot): void {
    this.resource_true_id = copyMe.resource_true_id;
    this.type_id = copyMe.type_id;
    this.level = copyMe.level;
    this.true_total = copyMe.true_total;
    this.true_used = copyMe.true_used;
    this.true_created = copyMe.true_created;
    this.slot_name = copyMe.slot_name;
  }
}
